import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import DomainIcon from '@mui/icons-material/Domain';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import PersonIcon from '@mui/icons-material/Person';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';

import AmbulanceIcon from './AmbulanceIcon/AmbulanceIcon';
import HelicopterIcon from './HelicopterIcon/HelicopterIcon';

const EARTH_RADIUS = 6371;
const toRadius = (x) => x * Math.PI / 180;

/**
 * Calculate the distance between two points in km according to the Haversine formula
 * @see https://fr.wikipedia.org/wiki/Formule_de_haversine
 * @see https://www.movable-type.co.uk/scripts/latlong.html
 * @param {Coord} pointA latitude and longitude of point A
 * @param {Coord} pointB latitude and longitude of point B
 * @returns distance between two point in KM
 */
export const getDistanceBetweenPointsHaversine = (pointA, pointB) => {
  const { longitudeA, latitudeA } = pointA;
  const { longitudeB, latitudeB } = pointB;
  const differenceLatitude = toRadius(latitudeB - latitudeA);
  const differenceLongitude = toRadius(longitudeB - longitudeA);

  // Formule d'Haversine
  const a = Math.pow(Math.sin(differenceLatitude / 2), 2) + Math.pow(Math.sin(differenceLongitude / 2), 2) * Math.cos(latitudeA) * Math.cos(latitudeB);
  const c = 2 * Math.asin(Math.sqrt(a));
  return EARTH_RADIUS * c;
};

const SAMU_SMUR_TYPE = 'SAMU_SMUR';
const SMUR_TYPE = 'SMUR';
const RECEIVING_FACILITY_TYPE = 'RECEIVING_FACILITY';

export const INTERVENTION_STATUS = {
  CREATED: 'CREATED',
  DISPATCHED: 'DISPATCHED',
  ACCEPTED: 'ACCEPTED',
  VALIDATED: 'VALIDATED',
  CLOSED: 'CLOSED',
};

// NOT USED YET
export const INTERVENTION_STATUS_COLOR_BY_STATUS = {
  [INTERVENTION_STATUS.CREATED]: '#c01d1c',
  [INTERVENTION_STATUS.DISPATCHED]: '#ed6c02',
  [INTERVENTION_STATUS.ACCEPTED]: '#2e7d32',
  [INTERVENTION_STATUS.VALIDATED]: '#1976d2',
  [INTERVENTION_STATUS.CLOSED]: '#BDBDBD', // default disabled MUI
};

export const getIconByItemType = (item) => {
  // Intervention
  if (item.interventionNumber) {
    return PersonIcon;
  }
  // smurTeams
  if (item.station.vector) {
    switch (item.station.vector) {
      case 'GROUND': {
        return AmbulanceIcon;
      }
      case 'AIR': {
        return HelicopterIcon;
      }
      case 'SEA': {
        return DirectionsBoatIcon;
      }
    }
  }
  // Facilities
  switch (item.type) {
    case SAMU_SMUR_TYPE: {
      return DomainIcon;
    }
    case SMUR_TYPE: {
      return LocalHospitalIcon;
    }
    case RECEIVING_FACILITY_TYPE: {
      return HomeWorkIcon;
    }
    default:
      return QuestionMarkIcon;
  }
};

export const getIconColorByStatus = (item) => {
  return item.station.busy ? '#ffa726' : '#66bb6a'; // warning main and success main from default MUI palette
  // if (item.type) {
  //   return !item.isOpen ? '#ed6c02' : '#2e7d32'; // warning main and success main from default MUI palette
  // }
  // return INTERVENTION_STATUS_COLOR_BY_STATUS[item.status];
};
